import React, { useEffect, useState } from "react";
import styles from "./WrapperDetailCard.module.scss";
import Download from "../../public/assets/icons/download.svg";
import Envelope from "../../public/assets/icons/envelope.svg";
import Whatsapp from "../../public/assets/icons/whatsapp.svg";
import ButtonWithIcon from "../ButtonWithIcon/ButtonWithIcon";

function urlEmailTitle(email) {
  let tmp = email.split(":");
  if(tmp.length > 1) return tmp[1];
  else return tmp[0];
}

const WrapperDetailCard = ({
  title,
  brandImg,
  titleCategories,
  category,
  info,
  content,
  links,
}) => {
  const [phone, setPhone] = useState();
  const [website, setWebsite] = useState();
  const [catalogue, setCatalogue] = useState();
  const [email, setEmail] = useState();
  const [whatsapp, setWhatsapp] = useState();
  const [external, setExternal] = useState();
  const [wechat, setWechat] = useState();

  useEffect(() => {
    if (links && links.length > 0) {
      let phones = []
      let wac = '';
      
      links.forEach((d) => {
        if (d?.type === "phone") {
          phones.push(d)
        } else if (d?.type === "website") {
          setWebsite(d);
        } else if (d?.type === "catalogue") {
          setCatalogue(d);
        } else if (d?.type === "email") {
          setEmail(d);
        } else if (d?.type === "whatsapp") {
          setWhatsapp(d);
        } else if (d?.type === "wechat") {
          setWechat(d);
        } else if (d?.type === "whatsapp_catalogue") {
          wac = {...d};
          wac.title = wac.title.toLowerCase();
          setWhatsapp(wac);
        } else if (d?.type === "external") {
          let tmp = {...d};
          tmp.title = d.catalog_title.toLowerCase();
          tmp.title = tmp.title.charAt(0).toUpperCase() + tmp.title.slice(1);
          setExternal(tmp)
        }
      });
      setPhone(phones);

    }
  }, [links]);


  let detailsLinks = [];
  if(email)
    detailsLinks.push(<div className={styles.button}><ButtonWithIcon link={email} outline={false} lightGold /></div>);
  if(whatsapp)
    detailsLinks.push(<div className={styles.button}><ButtonWithIcon link={whatsapp} outline={false} fill lightGold /></div>);
  if(external)
    detailsLinks.push(<div className={styles.button}><ButtonWithIcon link={external} outline={false} fill lightGold /></div>);
  if(wechat)
    detailsLinks.push(<div className={styles.button}><ButtonWithIcon link={wechat} outline={false} fill lightGold /></div>)

  return (
    <div className={styles.wrapperDetailCard}>
      <img src={brandImg?.src} alt={brandImg?.alt}></img>
      <div className={styles.cardContent}>
        <div className={`${styles.subsection} ${styles.firstSection}`}>
          <div>
            <span className={styles.lightText}>{titleCategories}</span>{" "}
            <span dangerouslySetInnerHTML={{__html: category}}></span>
          </div>
          <div>
            {((phone && phone.length > 0) || email) && <span className={styles.lightText}>{info}{" "}</span>}
            {phone && phone.length != 0 && 
              phone.map((p, i) => < a href={p.url} key={i} target={website?.target}> {p.title}</a>)
            }
            { (!phone || phone.length == 0) && email &&
              <a target={email.target} href={email.url}>{urlEmailTitle(email.url)}</a>
            }
            {" "}
            {website &&
              <>
                <br></br>
                <a href={website?.url} target={website?.target}>{" "}{website?.title.split("/")[0]}
                </a>
              </>
            }
          </div>
        </div>
        {catalogue && (
          <a
            className={`${styles.download} ${styles.subsection}`}
            href={catalogue.url}
          >
            <Download />
            {catalogue.title}
          </a>
        )}

        <div className={styles.subsection}>
          <div className={styles.title}>{title}</div>
          <div dangerouslySetInnerHTML={{ __html: content }}></div>
        </div>
      </div>
      {detailsLinks.length > 1 && <div className={styles.buttons}>{detailsLinks}</div>}
      {detailsLinks.length == 1 && <>{detailsLinks}</>}
    </div >
  );
};

export default WrapperDetailCard;
